import React from 'react'
import "./Pricing2.css"

function Pricing2() {
    function check() {
        var checkBox = document.getElementById("checbox");
        var pricing_text1 = document.getElementsByClassName("pricing_text1");
        var pricing_text2 = document.getElementsByClassName("pricing_text2");

        for (var i = 0; i < pricing_text1.length; i++) {
            if (checkBox.checked === true) {
                pricing_text1[i].style.display = "block";
                pricing_text2[i].style.display = "none";
            } else if (checkBox.checked === false) {
                pricing_text1[i].style.display = "none";
                pricing_text2[i].style.display = "block";
            }
        }
    }
    return (

        <div className="pricing_container">
            <div className="top">
                <p className='pr-p0'>Plans And Pricing</p>
                <p className='pr-p1'>Please select one of the plans to continue</p>
                {/* <div className="toggle-btn">
                    <span style={{margin: "0.8em"}}>Annually</span>
                    <label className="switch">
                        <input type="checkbox" id="checbox" onclick="check()"/>
                        <span className="slider round"></span>
                    </label>
                    <span style={{margin: "0.8em"}}>Monthly</span></div> */}
            </div>

            <div className="package-pricing_container">
                <div className="packages">
                    <h1>Starter</h1>
                    <h2 className="pricing_text1">Rs. 599/-</h2>
                    {/* <h2 className="pricing_text2">&dollar;119.99</h2> */}
                    <ul className="pricing_list">
                        <li className="pricing_first">Feature Explanation1: Lorem Ipsum</li>
                        <li>Feature1: Lorem Ipsum</li>
                        {/* <li>Multi-User Accounts</li>
                        <li>Email Support</li> */}
                    </ul>
                    <a href="/bhomepage" className="pricing_button pricing_button1">Start Now</a>
                </div>
                <div className="packages">
                    <h1>Pro</h1>
                    <h2 className="pricing_text1">Rs. 999/-</h2>
                    {/* <h2 className="pricing_text2">&dollar;239.99</h2> */}
                    <ul className="pricing_list">
                        <li className="pricing_first">Feature Explanation1: Lorem Ipsum</li>
                        <li>Feature1: Lorem Ipsum</li>
                        {/* <li className="pricing_first">Basic +</li>
                        <li>Landing Pages</li>
                        <li>Pop-up Forms</li>
                        <li>Premium Support</li> */}
                    </ul>
                    <a href="/bhomepage" className="pricing_button pricing_button2">Start Now</a>
                </div>
                <div className="packages">
                    <h1>Enterprice</h1>
                    <h2 className="pricing_text1">Rs. 1999/-</h2>
                    {/* <h2 className="pricing_text2">&dollar;359.99</h2> */}
                    <ul className="pricing_list">
                        <li className="pricing_first">Feature Explanation1: Lorem Ipsum</li>
                        <li>Feature1: Lorem Ipsum</li>
                        {/* <li className="pricing_first">Professional +</li>
                        <li>Marketing Automation</li>
                        <li>Instagram Ads</li>
                        <li>Facebook Ads</li> */}
                    </ul>
                    <a href="/bhomepage" className="pricing_button pricing_button3">Start Now</a>
                </div>
            </div>
        </div>
    )
}

export default Pricing2